export default {
  firstLevelCategories(state) {
    return state.autocompleteCategoryMenuData ? state.autocompleteCategoryMenuData.categories : [];
  },
  getShowPageDarkLayer(state) {
    return state.showPageDarkLayer;
  },
};
